<ng-template #content_more_action let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}">
        <div class="side_popup_header">
            <span>{{localService.languageContent.table.action + ' - ' + title}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="max-height: calc(100vh - 130px);">
            <div *ngFor="let item of items;">
                <div class="row" *ngIf="item && (quickSearchKey == '' || item.v5.indexOf(quickSearchKey.toLowerCase()) > -1)">
                    <div class="col-12">
                        <button class=" button_link link_btn" (click)="onAction(1,item.key)"
                            [disabled]="item.isReadonly == true">
                            <div class="btn_option">
                                <i class="material-icons menu_icon icon_adjust" style="{{item.v4 ?? ''}}">{{item.v2}}</i>
                                <label>{{item.v1}}</label>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12">
                    <input autocomplete="off" type="text" [(ngModel)]="quickSearchKey"
                        title="{{localService.languageContent.common.search}}" id="{{elementIds.txt_quick_search}}"
                        placeholder="{{localService.languageContent.common.search}}" />
                </div>
            </div>
        </div>
    </div>
</ng-template>